import gql from 'graphql-tag';

const FIRMWARE_VERSION_LIST_ADD = gql`
  mutation Mutation($version: String!) {
    addFirmwareVersion(version: $version) {
      code
    }
  }
`;

export default FIRMWARE_VERSION_LIST_ADD;
